import { render, staticRenderFns } from "./VerObraSocial.vue?vue&type=template&id=d855cbe0&"
import script from "./VerObraSocial.vue?vue&type=script&lang=js&"
export * from "./VerObraSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports